// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"36aa98d4","643":"8127c353","646":"f4a08e3f","667":"36aa98d4","724":"5991f967","735":"a75e5121","836":"36aa98d4","942":"e197dd30"}[chunkId] + ".chunk.css";
};